import Config from "../Config";
import Commons from "./Commons";
import RequestHelper from "./RequestHelper";

export default class GatewayCacheHandler
{
    static _nExpirationTime;
    static _aInstance = null;
    static _bUserInactive = true;

    static getInstance()
    {
        if (GatewayCacheHandler._aInstance == null)
        {
            GatewayCacheHandler._aInstance = new GatewayCacheHandler();
        }
        return GatewayCacheHandler._aInstance;
    }

    setExpirationTime = (nTime) =>
    {
        if (!isNaN(nTime))
        {
            GatewayCacheHandler._nExpirationTime = nTime;
        }
    }

    startObserving = async (messagingFn) =>
    {
        const checkActivity = () =>
        {
            GatewayCacheHandler._bUserInactive = false;
        }
        document.addEventListener('keydown', checkActivity);
        document.addEventListener('mousedown', checkActivity);

        const checkToken = () =>
        {
            if (GatewayCacheHandler._bUserInactive)
            {
                if (!localStorage["gateway_token"])
                {
                    return;
                }
                let aNow = new Date();
                let aExpireDate = new Date(JSON.parse(localStorage["gateway_token"]).expire);
                let nTimeToExpireMs = aExpireDate.getTime() - aNow.getTime();

                if (nTimeToExpireMs <= 0)
                {
                    messagingFn(0, true);
                    return;
                }
                if (nTimeToExpireMs <= Config.tokenWarningTime)
                {
                    let nTimeS = Math.round(nTimeToExpireMs / 1000);
                    messagingFn((0 < nTimeS ? nTimeS : 0), false);
                }
            }
            else
            {
                RequestHelper.sendRequestSimple(
                {
                    request: Commons.createGatewayRequestUrl(
                    {
                        url: Config.anpRequestUrl.testAuth,
                        endpoint: Config.requestSession
                    }),
                    dataType: "text",
                }).then((aData) =>
                {
                    if (aData && "string" === typeof aData)
                    {
                        aData = JSON.parse(aData);
                    }
                    if (!aData.isErr && aData.hasOwnProperty("token") && aData.token && aData.hasOwnProperty("expire") && aData.expire)
                    {
                        if (localStorage["user_name"])
                        {
                            localStorage["gateway_token"] = JSON.stringify(aData);
                        }
                    }
                    else
                    {
                        localStorage.removeItem("gateway_token");
                        localStorage.removeItem("user_name");
                    }
                }).catch((aEx) =>
                {
                    console.error("Failed to refresh token");
                });
            }
            GatewayCacheHandler._bUserInactive = true;
            setTimeout(checkToken, Config.tokenCheckTimePeriod);
        }
        setTimeout(checkToken, Config.tokenCheckTimePeriod);
    }
}